import {Component} from '@angular/core';
import {AbstractDynamicFormFieldDirective} from './abstract-dynamic-form-field.directive';

@Component({
  selector: 'app-dff-radio-button-group',
  templateUrl: './dff-radio-button-group.component.html',
  styleUrls: ['./dff-radio-button-group.component.scss']
})
export class DffRadioButtonGroupComponent extends AbstractDynamicFormFieldDirective {

  value = '';

  validate(value: string): string[] {
    return [];
  }

  writeValue(value: string) {
    this.value = value;
  }

  changed(value: string) {
    this.value = value;
    this.changeValue(this.value);
  }
}
